@file:OptIn(ExperimentalMaterial3Api::class)

package us.laantech.laanmanage.feature.reports.z.ui

import androidx.compose.foundation.BorderStroke
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.verticalScroll
import androidx.compose.material3.*
import androidx.compose.runtime.*
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import androidx.lifecycle.viewmodel.compose.viewModel
import androidx.lifecycle.viewmodel.initializer
import androidx.lifecycle.viewmodel.viewModelFactory
import us.laantech.common.ui.DateTimeEntryModal

import us.laantech.common.util.tryFormatAsDateTime
import us.laantech.common.ui.DropdownMenu

@Composable
fun ZReportView(
    viewModel: ZReportViewModel = viewModel(
        factory = viewModelFactory {
            initializer {
                ZReportViewModel()
            }
        }
    )
) {

    val uiState by viewModel.uiState.collectAsState()

    LaunchedEffect(Unit) {
// FIXME loadEmployeeList prevents loading fix
        viewModel.loadEmployeeList()
        viewModel.loadReport()
    }

    Surface {

        Column(
            modifier = Modifier
                .fillMaxSize()
                .verticalScroll(rememberScrollState())
        ) {

            // Filter controls

            // Shortcuts
            Text("Shortcuts")
            FlowRow(
                modifier = Modifier
                    .fillMaxWidth()
                    .padding(8.dp), horizontalArrangement = Arrangement.SpaceEvenly
            ) {
                mapOf<String, () -> Unit>(
                    "Today" to { viewModel.setRange(0L) },
                    "Last 7 Days" to { viewModel.setRange(7L) },
                    "Last 30 Days" to { viewModel.setRange(30L) },
                    "Last 60 Days" to { viewModel.setRange(60L) },
                    ).forEach { (label, action) ->
                    Button(
                        action,
                        border = BorderStroke(1.dp, Color.Gray)
                    ) { Text(label) }

                }
            }

            // Time Range
            Row(
                modifier = Modifier
                    .fillMaxWidth()
                    .padding(8.dp), horizontalArrangement = Arrangement.spacedBy(8.dp)
            ) {
//                    Text("From")
                val fontSize = 24.sp

                // From Date
                Button(
                    { viewModel.showStartDatePicker() },
                    modifier = Modifier.weight(1f),
                    shape = MaterialTheme.shapes.extraLarge,
                    colors = ButtonDefaults.buttonColors(containerColor = MaterialTheme.colorScheme.primary),
                    border = BorderStroke(1.dp, MaterialTheme.colorScheme.onPrimary)
                ) {
                    Text("From\n${uiState.fromDateTime.tryFormatAsDateTime()}", fontSize = fontSize, lineHeight = 32.sp, textAlign = TextAlign.Center)
                }

                // To Date
                Button(
                    { viewModel.showEndDatePicker() },
                    modifier = Modifier.weight(1f),
                    shape = MaterialTheme.shapes.extraLarge,
                    colors = ButtonDefaults.buttonColors(containerColor = MaterialTheme.colorScheme.primary),
                    border = BorderStroke(1.dp, MaterialTheme.colorScheme.onPrimary)
                ) {
                    Text("To\n${uiState.toDateTime.tryFormatAsDateTime()}", fontSize = fontSize, lineHeight = 32.sp, textAlign = TextAlign.Center)

                }
            }

            // Store or Branch Select
            Text("TODO  Select Store")
            SingleChoiceSegmentedButtonRow(modifier = Modifier.fillMaxWidth()) {
                uiState.reportScopes.forEachIndexed { index, label ->
                    SegmentedButton(
                        shape = SegmentedButtonDefaults.itemShape(
                            index = index,
                            count = uiState.reportScopes.size
                        ),
                        onClick = { viewModel.selectReportScope(index) },
                        selected = (index == uiState.selectedScopeIndex),
                        label = { Text(label) }
                    )
                }
            }

            // Select employee or none
            var employeeMenuExpanded by remember { mutableStateOf(false) }
            val selectedEmployee = uiState.employeeList
                .firstOrNull { it.uuid == uiState.selectedEmployeeUUID }

            Text("Employee")
            DropdownMenu(
                label = "Employee",
                items = uiState.employeeList,
                selectedItem = selectedEmployee,
                itemLabel = { it.employeeName ?: "" },
                noneLabel = "Any Employee",
                onItemSelected = { employee -> viewModel.selectEmployee(employee?.uuid) },
            )


            // Report Display
            Text("Z Report ${uiState.zReport?.header}")

            val dataTables = uiState.zReport?.sections
            dataTables?.forEach { dt ->
                ReportCard(dt)
            }

        }
    }


    if (uiState.showStartDatePicker) {
        DateTimeEntryModal(
            initialEpochMillis = uiState.fromDateTime,
            title = "Select Start Date",
            onDismiss = {
                viewModel.closeStartDatePicker()
            },
            onConfirm = { epochMillis ->
                viewModel.updateFromDateTime(epochMillis)
                viewModel.closeStartDatePicker()
            },
        )
    } else if (uiState.showEndDatePicker) {
        DateTimeEntryModal(
            initialEpochMillis = uiState.toDateTime,
            title = "Select End Date",
            onDismiss = {
                viewModel.closeEndDatePicker()
            },
            onConfirm = { epochMillis ->
                viewModel.updateToDateTime(epochMillis)
                viewModel.closeEndDatePicker()
            },
        )
    }


}